(function () {
  // Column names on each cell, so tables can stack into labelled rows on phones
  document.querySelectorAll('.mc table').forEach(t => {
    const heads = Array.from(t.querySelectorAll('thead th')).map(th => th.textContent.trim());
    t.querySelectorAll('tbody tr').forEach(tr => {
      Array.from(tr.children).forEach((td, i) => { if (heads[i]) td.setAttribute('data-label', heads[i]); });
    });
  });

  // Button-press demo on the drawing: keys light in a zoom / pan / recentre sequence.
  const keys = Array.from(document.querySelectorAll('.mc #keys .key'));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduce && keys.length) {
    const order = [0, 0, 3, 2, 1, 6];
    let i = 0;
    setInterval(() => {
      keys.forEach(k => k.classList.remove('lit'));
      keys[order[i % order.length]].classList.add('lit');
      i++;
    }, 900);
  }

  // Ride clip: respect reduced motion
  document.querySelectorAll('.ride-video video').forEach(v => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { v.removeAttribute('autoplay'); v.pause(); v.controls = true; }
  });

  // Video placeholder
  const play = document.getElementById('play-video');
  if (play) play.addEventListener('click', () => {
    play.closest('.video').querySelector('.vlabel span').textContent = 'Video not added yet. Your ride clip will play here.';
  });

  // ---------- See it move: map demo ----------
  (function mapDemo() {
    const svgNS = 'http://www.w3.org/2000/svg';
    const world = document.getElementById('world');
    const riderLayer = document.getElementById('rider-fixed');
    if (!world) return;
    const VW = 360, VH = 680, CX = VW / 2, CY = VH * 0.58;
    const rider = { x: 520, y: 560, heading: 38 };   // world units = metres; heading in degrees from north

    function el(tag, attrs, parent) {
      const e = document.createElementNS(svgNS, tag);
      for (const k in attrs) {
        const val = String(attrs[k]);
        // CSS variables only resolve through style, not presentation attributes
        if (val.startsWith('var(')) e.style.setProperty(k, val);
        else e.setAttribute(k, val);
      }
      (parent || world).appendChild(e);
      return e;
    }
    const v = n => 'var(--' + n + ')';

    // ---- map content (a fictional valley, 1200 x 1200 m) ----
    el('rect', { x: -800, y: -800, width: 2800, height: 2800, fill: v('map-land') });
    [['M80 120 C200 60 330 110 360 230 C380 330 250 380 150 340 C60 300 20 200 80 120Z'],
     ['M760 820 C900 760 1080 820 1100 960 C1110 1080 960 1120 840 1060 C740 1010 700 880 760 820Z'],
     ['M900 120 C1000 90 1120 160 1110 260 C1100 340 980 360 920 300 C860 240 840 150 900 120Z']]
      .forEach(([d]) => el('path', { d, fill: v('map-wood') }));
    for (let r = 60; r <= 300; r += 40) {
      el('ellipse', { cx: 960, cy: 300, rx: r * 1.25, ry: r * 0.9, fill: 'none', stroke: v('map-contour'), 'stroke-width': 1.2, transform: 'rotate(-18 960 300)' });
    }
    for (let r = 50; r <= 210; r += 40) {
      el('ellipse', { cx: 160, cy: 960, rx: r, ry: r * 0.7, fill: 'none', stroke: v('map-contour'), 'stroke-width': 1.2 });
    }
    el('path', { d: 'M-200 760 C80 700 240 820 420 760 C600 700 680 560 860 600 C1020 640 1150 560 1400 600', fill: 'none', stroke: v('map-water'), 'stroke-width': 16, 'stroke-linecap': 'round' });
    el('ellipse', { cx: 300, cy: 300, rx: 70, ry: 40, fill: v('map-water') });
    const roads = [
      ['M-200 520 C100 520 300 470 520 560 C700 640 900 600 1400 520', 14],
      ['M520 -200 C500 100 560 300 520 560 C490 760 600 1000 560 1400', 11],
      ['M520 560 C660 470 760 360 900 260 C1000 190 1100 160 1400 100', 9],
      ['M100 -200 C140 200 120 420 220 520', 7],
      ['M560 1000 C760 1060 900 1000 1100 1080', 7],
      ['M220 520 C200 700 120 860 160 1100', 7]
    ];
    roads.forEach(([d, w]) => el('path', { d, fill: 'none', stroke: v('map-road-edge'), 'stroke-width': w + 3, 'stroke-linecap': 'round' }));
    roads.forEach(([d, w]) => el('path', { d, fill: 'none', stroke: v('map-road'), 'stroke-width': w, 'stroke-linecap': 'round' }));
    el('path', { d: 'M300 470 C420 490 470 520 520 560 C660 470 760 360 900 260 C1000 190 1060 170 1180 130', fill: 'none', stroke: v('map-route'), 'stroke-width': 7, 'stroke-linecap': 'round', 'stroke-linejoin': 'round', opacity: 0.9 });
    const labels = [];
    [['Ridge Pass', 960, 300], ['Lower Ford', 330, 760], ['Fuel', 230, 505], ['Camp', 1090, 1060], ['Lake', 300, 302]].forEach(([t, x, y]) => {
      const g = el('g', { transform: 'translate(' + x + ' ' + y + ')' });
      const tx = el('text', { 'text-anchor': 'middle', 'font-family': 'IBM Plex Mono, monospace', 'font-size': 13, fill: v('map-label'), 'paint-order': 'stroke', stroke: v('map-land'), 'stroke-width': 3 }, g);
      tx.textContent = t;
      labels.push(g);
    });
    // rider marker (lives in the world so it moves when you pan)
    const riderG = el('g', {});
    el('circle', { r: 16, fill: v('map-route'), opacity: 0.18 }, riderG);
    el('circle', { r: 9, fill: '#ffffff' }, riderG);
    const arrow = el('path', { d: 'M0 -7 L5.5 5 L0 2.5 L-5.5 5 Z', fill: v('map-route') }, riderG);

    // ---- view state ----
    const ZOOMS = [0.35, 0.5, 0.7, 1, 1.4, 2, 2.8];  // px per metre
    const start = { x: rider.x, y: rider.y, zi: 3, rot: 0 };
    let target = Object.assign({}, start);
    let view = Object.assign({}, start, { z: ZOOMS[start.zi] });
    let following = true;

    function render() {
      world.setAttribute('transform', 'translate(' + CX + ' ' + CY + ') rotate(' + (-view.rot) + ') scale(' + view.z + ') translate(' + (-view.x) + ' ' + (-view.y) + ')');
      riderG.setAttribute('transform', 'translate(' + rider.x + ' ' + rider.y + ') scale(' + (1 / view.z) + ') rotate(' + rider.heading + ')');
      labels.forEach(g => {
        const t = g.getAttribute('transform').split(' scale')[0];
        g.setAttribute('transform', t + ' scale(' + (1 / view.z) + ') rotate(' + view.rot + ')');
      });
      document.getElementById('compass').style.transform = 'rotate(' + (-view.rot) + 'deg)';
    }
    function hud() {
      document.getElementById('hud-zoom').textContent = 'Zoom ' + (target.zi + 1) + ' of ' + ZOOMS.length;
      document.getElementById('hud-mode').textContent = (target.rot ? 'Heading up' : 'North up') + (following ? '' : ' · free');
      // scale bar: pick a round distance that is 40-100 px long
      const z = ZOOMS[target.zi];
      const nice = [20, 50, 100, 200, 500, 1000, 2000];
      const m = nice.find(n => n * z >= 40) || 2000;
      document.getElementById('scale-line').style.width = Math.round(m * z) + 'px';
      document.getElementById('scale-text').textContent = m >= 1000 ? (m / 1000) + ' km' : m + ' m';
    }
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let raf = 0;
    function animate() {
      const k = reduce ? 1 : 0.2;
      const tz = ZOOMS[target.zi];
      let dr = target.rot - view.rot;
      view.x += (target.x - view.x) * k;
      view.y += (target.y - view.y) * k;
      view.z += (tz - view.z) * k;
      view.rot += dr * k;
      render();
      const done = Math.abs(target.x - view.x) < 0.3 && Math.abs(target.y - view.y) < 0.3 && Math.abs(tz - view.z) < 0.002 && Math.abs(dr) < 0.1;
      if (done) { view.x = target.x; view.y = target.y; view.z = tz; view.rot = target.rot; render(); raf = 0; }
      else raf = requestAnimationFrame(animate);
    }
    function kick() { hud(); if (!raf) raf = requestAnimationFrame(animate); }

    // pan in screen directions, converted to map directions when the map is rotated
    function pan(dx, dy) {
      const step = 70 / ZOOMS[target.zi];
      const a = target.rot * Math.PI / 180;
      const wx = dx * Math.cos(a) - dy * Math.sin(a);
      const wy = dx * Math.sin(a) + dy * Math.cos(a);
      target.x += wx * step; target.y += wy * step;
      following = false;
    }
    const ACTIONS = {
      1: { key: '+', name: 'Zoom in', run: () => { target.zi = Math.min(ZOOMS.length - 1, target.zi + 1); } },
      2: { key: '−', name: 'Zoom out', run: () => { target.zi = Math.max(0, target.zi - 1); } },
      3: { key: 'C', name: 'Recentre', run: () => { target.x = rider.x; target.y = rider.y; following = true; } },
      4: { key: 'N', name: 'North up', run: () => { target.rot = 0; } },
      '4L': { key: 'D', name: 'Heading up', run: () => { target.rot = rider.heading; target.x = rider.x; target.y = rider.y; following = true; } },
      5: { key: '↑', name: 'Pan up', run: () => pan(0, -1) },
      6: { key: '←', name: 'Pan left', run: () => pan(-1, 0) },
      7: { key: '→', name: 'Pan right', run: () => pan(1, 0) },
      8: { key: '↓', name: 'Pan down', run: () => pan(0, 1) }
    };
    const REPEAT = { 1: 1, 2: 1, 5: 1, 6: 1, 7: 1, 8: 1 };
    const faceSvg = document.getElementById('face');
    let demoInView = false;
    if ('IntersectionObserver' in window) new IntersectionObserver(es => { demoInView = es[0].isIntersecting; }).observe(world.closest('.mc'));
    let ledTimer = 0;
    function blinkLed() {
      faceSvg.classList.add('led-on');
      clearTimeout(ledTimer);
      ledTimer = setTimeout(() => faceSvg.classList.remove('led-on'), 120);
    }
    function send(id) {
      const a = ACTIONS[id];
      a.run();
      blinkLed();
      document.getElementById('sent-text').innerHTML = '<kbd>' + a.key + '</kbd> ' + a.name;
      kick();
    }

    // press / hold behaviour, like the firmware: arrows and zoom repeat; B7 hold = heading up
    let holdTimer = 0, repeatTimer = 0, longDone = false, activeBtn = null;
    function pressStart(btn) {
      stopDemo();
      const b = btn.dataset.b;
      activeBtn = btn; longDone = false; btn.classList.add('down');
      if (REPEAT[b]) {
        send(b);
        holdTimer = setTimeout(() => { repeatTimer = setInterval(() => send(b), 160); }, 450);
      } else if (b === '4') {
        holdTimer = setTimeout(() => { longDone = true; send('4L'); }, 700);
      }
    }
    function pressEnd() {
      if (!activeBtn) return;
      const b = activeBtn.dataset.b;
      clearTimeout(holdTimer); clearInterval(repeatTimer);
      if (!REPEAT[b] && !longDone) send(b);
      activeBtn.classList.remove('down'); activeBtn = null;
    }
    document.querySelectorAll('#face .fkey').forEach(btn => {
      btn.addEventListener('pointerdown', e => { e.preventDefault(); btn.setPointerCapture && btn.setPointerCapture(e.pointerId); pressStart(btn); });
      btn.addEventListener('pointerup', pressEnd);
      btn.addEventListener('pointercancel', pressEnd);
      btn.addEventListener('keydown', e => { if ((e.key === 'Enter' || e.key === ' ') && !e.repeat) { e.preventDefault(); pressStart(btn); } });
      btn.addEventListener('keyup', e => { if (e.key === 'Enter' || e.key === ' ') pressEnd(); });
    });
    // physical keyboard, only while this page is showing
    const KEYMAP = { '+': 1, '=': 1, '-': 2, c: 3, n: 4, d: '4L', ArrowUp: 5, ArrowLeft: 6, ArrowRight: 7, ArrowDown: 8 };
    document.addEventListener('keydown', e => {
      if (!demoInView) return;
      if (e.target.closest && e.target.closest('input, textarea, button')) return;
      const id = KEYMAP[e.key];
      if (id === undefined) return;
      e.preventDefault(); stopDemo();
      const btn = document.getElementById('b' + String(id).replace('L', ''));
      btn.classList.add('down'); setTimeout(() => btn.classList.remove('down'), 140);
      send(id);
    });

    // scripted ride demo
    const SCRIPT = [[2, 700], [2, 700], [7, 450], [7, 450], [5, 450], [1, 700], [1, 700], [3, 900], ['4L', 1200], [1, 700], [4, 1000], [3, 600]];
    let demoTimers = [];
    function stopDemo() { demoTimers.forEach(clearTimeout); demoTimers = []; }
    function playDemo() {
      stopDemo();
      let t = 0;
      SCRIPT.forEach(([id, wait]) => {
        demoTimers.push(setTimeout(() => {
          const btn = document.getElementById('b' + String(id).replace('L', ''));
          btn.classList.add('down'); setTimeout(() => btn.classList.remove('down'), 220);
          send(id);
        }, t));
        t += wait;
      });
    }
    document.getElementById('demo-play').addEventListener('click', playDemo);
    document.getElementById('demo-reset').addEventListener('click', () => {
      stopDemo(); target = Object.assign({}, start); following = true;
      document.getElementById('sent-text').textContent = 'Nothing yet. Press a button.';
      kick();
    });

    render(); hud();
  })();
})();
